<script>
import { VueTyper } from "vue-typer";
import { ArrowUpIcon, PlayIcon } from "vue-feather-icons";
import countTo from "vue-count-to";
import i18n from '@/i18n'
import { getAllPlansApi } from '@/api'
import { Spin } from 'ant-design-vue'

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing2";
import News from "@/components/news";
import HeroBanner from './home-banner';

/**
 * Index-business component
 */
export default {
  data() {
    return {
      featuresData: [
        {
          icon: require('@/assets/images/icon/icon-1.png'),
          title: i18n.t('选择SIM卡'),
          description:
            i18n.t('根据您的需求，选择最适合的SIM卡套餐，享受畅通无阻的通信体验。无论是国内还是国际流量，我们都有多种方案供您选择。'),
        },
        {
          icon: require('@/assets/images/icon/icon-2.png'),
          title: i18n.t('号码充值'),
          description:
            i18n.t('轻松为您的SIM卡充值，随时随地保持通信畅通。支持多种支付方式，让充值变得更加便捷。'),
        },
        {
          icon: require('@/assets/images/icon/icon-3.png'),
          title: i18n.t('我的订单'),
          description:
            i18n.t('在“我的订单”中，查看您的历史购买记录，管理您的SIM卡和充值服务，随时掌握最新动态。'),
        },
      ],
      pricingData: [
        {
          title: "60G",
          price: 49,
          originPrice: 49,
          tag: i18n.t('新品促销赠送 15GB 本地流量'),
          feature: [
            i18n.t('4G速率/ 无合约'),
            i18n.t('30GB流量 ，其中10GB可在中国内地及中国香港漫游使用'),
            i18n.t('免费本地流量滚存，累积至下个月。每月最多可累积 50GB'),
            i18n.t('100分钟本地拨打中国及中国香港国际长途语音'),
            i18n.t('1GB马来西亚、印尼及泰国漫游流量', { x: 1 }),
            i18n.t('200分钟本地主叫语音'),
            i18n.t('200条本地短信'),
            i18n.t('免费来电显示'),
            i18n.t('免费无限本地被叫'),
            i18n.t('30GB 中包含新品促销赠送 15GB 本地流量/月，连续赠送6个月'),
          ],
          button: i18n.t('立即购买'),
          id: 1,
          star: require('@/assets/images/price/price-1-star.png'),
          topColor: ['#15A9F0', '#70E0FF'],
          priceColor: '#0D9ADC',
          btnColor: 'background: linear-gradient(90.48deg, #1FB6FF 7.31%, #2DDEED 97.94%);',
        },
        {
          title: "200G",
          price: 89,
          originPrice: 89,
          tag: i18n.t('新品促销赠送 100GB 本地流量'),
          feature: [
            i18n.t('4G速率/ 无合约'),
            i18n.t('200GB流量，其中35GB可在中国内地及中国香港漫游使用'),
            i18n.t('免费本地流量滚存，累积至下个月。每月最多可累积 365GB'),
            i18n.t('100分钟本地拨打中国及中国香港国际长途语音'),
            i18n.t('1GB马来西亚、印尼及泰国漫游流量', { x: 2 }),
            i18n.t('300分钟本地主叫语音'),
            i18n.t('300条本地短信'),
            i18n.t('免费来电显示'),
            i18n.t('免费无限本地被叫'),
            i18n.t('200GB 中包含新品促销赠送 100GB 本地流量/月，连续赠送6个月'),
          ],
          button: i18n.t('立即购买'),
          id: 2,
          star: require('@/assets/images/price/price-2-star.png'),
          topColor: ['#54A5FD', '#81ACFD'],
          priceColor: '#0640E8',
          btnColor: 'background: linear-gradient(90deg, #54A5FD 0%, #81ACFD 93.31%);',
        },
        {
          title: "250G",
          price: 119,
          originPrice: 119,
          tag: i18n.t('新品促销赠送 130GB 本地流量'),
          feature: [
            i18n.t('5G速率/ 无合约'),
            i18n.t('250GB流量，其中45GB可在中国内地及中国香港漫游使用'),
            i18n.t('免费本地流量滚存，累积至下个月。每月最多可累积 455GB'),
            i18n.t('100分钟本地拨打中国及中国香港国际长途语音'),
            i18n.t('1GB马来西亚、印尼及泰国漫游流量', { x: 4 }),
            i18n.t('400分钟本地主叫语音'),
            i18n.t('400条本地短信'),
            i18n.t('免费来电显示'),
            i18n.t('免费无限本地被叫'),
            i18n.t('免费5G服务'),
            i18n.t('250GB 中包含新品促销赠送 130GB 本地流量/月，连续赠送6个月'),
          ],
          button: i18n.t('立即购买'),
          id: 3,
          star: require('@/assets/images/price/price-3-star.png'),
          topColor: ['#B06FEF', '#E8BCF9'],
          priceColor: '#9B4CE6',
          btnColor: 'background: linear-gradient(90.18deg, #B06FEF 3.06%, #E8BCF9 99.84%);',
        },
        {
          title: "300G",
          price: 159,
          originPrice: 159,
          tag: i18n.t('新品促销赠送 150GB 本地流量'),
          feature: [
            i18n.t('5G速率/ 无合约'),
            i18n.t('300GB流量，其中60GB可在中国内地及中国香港漫游使用'),
            i18n.t('免费本地流量滚存，累积至下个月。每月最多可累积 540GB'),
            i18n.t('100分钟本地拨打中国及中国香港国际长途语音'),
            i18n.t('1GB马来西亚、印尼及泰国漫游流量', { x: 6 }),
            i18n.t('500分钟本地主叫语音'),
            i18n.t('500条本地短信'),
            i18n.t('免费来电显示'),
            i18n.t('免费无限本地被叫'),
            i18n.t('免费5G服务'),
            i18n.t('300GB 中包含新品促销赠送 150GB 本地流量/月，连续赠送6个月'),
          ],
          button: i18n.t('立即购买'),
          id: 4,
          star: require('@/assets/images/price/price-4-star.png'),
          topColor: ['#F6B94F', '#F9C95F'],
          priceColor: '#C2612E',
          btnColor: 'background: linear-gradient(180deg, #F6B94F 0%, #F9C95F 90.34%);',
        },
      ],
      plans: [],
      plansLoading: true,
    };
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    ArrowUpIcon,
    PlayIcon,
    "vue-typer": VueTyper,
    countTo,
    Pricing,
    News,
    'a-spin': Spin,
    HeroBanner,
  },
  mounted () {
    if (this.$route.query.ref && !localStorage.getItem('ref')) {
      localStorage.setItem('ref', this.$route.query.ref)
    }

    if (this.$route.query.inviter && !localStorage.getItem('inviter')) {
      localStorage.setItem('inviter', this.$route.query.inviter)
    }

    this.getPlans()
  },
  methods: {
    async getPlans () {
      this.plansLoading = true
      try {
        const data = await getAllPlansApi({
          inviter: this.$store.state.userInfo.inviter || localStorage.getItem('inviter') || localStorage.getItem('ref') || '',
        })

        this.plans = data
        this.pricingData = this.pricingData.map((v, index) => {
          const match = data.find(iv => iv.id * 1 === v.id * 1)
          return {
            ...v,
            price: match?.price || v.price,
            id: match?.id || v.id,
          }
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.plansLoading = false
      }
    },
    goPlan () {
      const element = document.getElementById('plan-area');
      console.log(element)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <HeroBanner></HeroBanner>
    <!--end section-->
    <!-- Button trigger modal -->

    <!-- Hero End -->

    <!-- Feature Start -->
    <section class="section section-hot-services">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">{{ $t('热门服务') }}</h4>
              <p class="para-desc mx-auto mb-0">
                {{ $t('提供各类热门通信服务，满足不同用户的需求。从国际漫游到数据流量套餐，我们的服务覆盖全面，便捷实用。') }}
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="row mt-5">
          <div
            class="col-md-4 col-12"
            v-for="(item, index) of featuresData"
            :key="index"
          >
            <div class="features hot-service-item">
              <!-- <div class="image position-relative d-inline-block">
                <i :class="`${item.icon} h1 text-primary`"></i>
              </div> -->
              <img :src="item.icon" alt="features">

              <div class="content mt-3">
                <h5>{{ item.title }}</h5>
                <p class="mb-0">{{ item.description }}</p>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- End feature -->

    <!-- Price Start -->
    <section id="plan-area" class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">{{ $t('选择套餐') }}</h4>
              <p class="para-desc mb-0 mx-auto">
                <!-- Start working with
                <span class="text-primary font-weight-bold">KTK</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect. -->
                {{ $t('选择适合您的SIM套餐，享受无缝连接体验。无论是数据、语音还是国际漫游，我们的灵活套餐助您轻松满足多样化需求。') }}
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
        <a-spin :spinning="plansLoading"">
          <Pricing :pricingData="pricingData" />
        </a-spin>
      </div>
      <!--end container-->
      <!-- Price End -->
    </section>
    <!--end section-->
    <section style="background: #F9FBFF;" class="section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title mb-4">
                <!-- See everything about your
                <span class="text-primary">KTK</span> Business -->
                {{ $t('了解我们的全球 SIM 卡服务') }}
              </h4>
              <p class="para-desc mb-0 mx-auto">
                <!-- Start working with
                <span class="text-primary font-weight-bold">KTK</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect. -->
                {{ $t('立即连接我们的 SIM 卡解决方案，享受覆盖新加坡、中国、香港、泰国和马来西亚的无缝移动网络服务。无论身在何处，都能享受高速、可靠的连接体验。') }}
              </p>
            </div>
          </div>

          <div class="net">
            <ul class="list-unstyled count">
              <li>
                <div class="number">98%</div>
                <div class="number-label">
                  {{ $t('用户满意度') }}
                </div>
              </li>
              <li>
                <div class="number">97%</div>
                <div class="number-label">
                  {{ $t('网络可用性') }}
                </div>
              </li>
              <li>
                <div class="number">20+</div>
                <div class="number-label">
                  {{ $t('业务合作伙伴') }}
                </div>
              </li>
              <li>
                <div class="number">15+</div>
                <div class="number-label">
                  {{ $t('服务奖项') }}
                </div>
              </li>
            </ul>

            <ul class="list-unstyled text-muted intro">
              <li class="">
                <span class="mr-2"
                  ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.2343 4.32214C14.6248 4.71266 14.6248 5.34583 14.2343 5.73635L7.65697 12.3137C7.29093 12.6797 6.71149 12.7029 6.31872 12.3827L6.24276 12.3137L2.87779 8.94872C2.48737 8.55819 2.4873 7.92499 2.87779 7.5345C3.26829 7.14414 3.90151 7.14412 4.292 7.5345L6.94987 10.1924L12.8201 4.32214C13.2106 3.93164 13.8438 3.93162 14.2343 4.32214Z" fill="url(#paint0_linear_19_5825)"/>
                  <defs>
                  <linearGradient id="paint0_linear_19_5825" x1="6.85647" y1="4.66747" x2="7.18766" y2="9.36078" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#55EE94"/>
                  <stop offset="1" stop-color="#1CC841"/>
                  </linearGradient>
                  </defs>
                  </svg>
                  </i></span
                >{{ $t('覆盖亚洲多国的全面网络') }}
              </li>
              <li class="">
                <span class="mr-2"
                  ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.2343 4.32214C14.6248 4.71266 14.6248 5.34583 14.2343 5.73635L7.65697 12.3137C7.29093 12.6797 6.71149 12.7029 6.31872 12.3827L6.24276 12.3137L2.87779 8.94872C2.48737 8.55819 2.4873 7.92499 2.87779 7.5345C3.26829 7.14414 3.90151 7.14412 4.292 7.5345L6.94987 10.1924L12.8201 4.32214C13.2106 3.93164 13.8438 3.93162 14.2343 4.32214Z" fill="url(#paint0_linear_19_5825)"/>
                  <defs>
                  <linearGradient id="paint0_linear_19_5825" x1="6.85647" y1="4.66747" x2="7.18766" y2="9.36078" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#55EE94"/>
                  <stop offset="1" stop-color="#1CC841"/>
                  </linearGradient>
                  </defs>
                  </svg>
                  </i></span
                >{{ $t('灵活套餐，满足各种需求') }}
              </li>
              <li class="">
                <span class="mr-2"
                  ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.2343 4.32214C14.6248 4.71266 14.6248 5.34583 14.2343 5.73635L7.65697 12.3137C7.29093 12.6797 6.71149 12.7029 6.31872 12.3827L6.24276 12.3137L2.87779 8.94872C2.48737 8.55819 2.4873 7.92499 2.87779 7.5345C3.26829 7.14414 3.90151 7.14412 4.292 7.5345L6.94987 10.1924L12.8201 4.32214C13.2106 3.93164 13.8438 3.93162 14.2343 4.32214Z" fill="url(#paint0_linear_19_5825)"/>
                  <defs>
                  <linearGradient id="paint0_linear_19_5825" x1="6.85647" y1="4.66747" x2="7.18766" y2="9.36078" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#55EE94"/>
                  <stop offset="1" stop-color="#1CC841"/>
                  </linearGradient>
                  </defs>
                  </svg>
                  </i></span
                >{{ $t('简化国际旅行连接体验') }}
              </li>
            </ul>
          </div>
        </div>
        <!--end row-->
      </div>
    </section>

    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style lang="scss">
.vue-typer .custom.char.typed {
  color: #2f55d4;
}
.pb-27 {
  padding-top: 54px;
  padding-bottom: 54px;
}
.bg-cta {
  background-size: cover!important;
  background-position: center center!important;
}

.section-hot-services {
  background-color: #F9FBFF;
}

.hot-service-item {
  background-color: #fff;
  border: 1px solid;
  border-image-source: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 16px;
  padding: 16px;

  img {
    height: 64px;
  }

  .content {
    h5 {
      color: #1A1B21;
      font-size: 20px!important;
      font-weight: 400;
    }

    p {
      color: #575574;
      margin-top: 16px;
      font-size: 14px;
      line-height: 20px;
      min-height: 60px;
    }
  }
}

.net {
  min-height: 474px;
  margin-top: 20px;
  width: 100%;
  background-size: cover;
  background-image: url("../../assets/images/world-min.png");
  box-sizing: border-box;
  background-position: center;
  padding-top: 20px;

  .count {
    display: flex;

    li {
      flex: 1;
      .number {
        font-weight: bold;
        font-size: 48px;
        color: #2F55D4;
      }
      .number-label {
        color: #1A1B21;
        font-size: 16px;
      }
    }

    @media screen and (max-width: 500px) {
      flex-wrap: wrap;
      padding: 16px;
      li {
        width: 50%;
        flex: unset;
      }
    }
  }

  .intro {
    margin-top: 120px;

    li {
      display: flex;
      color: #575574;
      svg {
        min-width: 16px;
        transform: translateY(3px);
      }

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    @media screen and (max-width: 500px) {
      padding: 16px;
      margin-top: 64px;
    }
  }
}
</style>
